import { useEffect, useState } from "react";
import { getNewsStockfactorReport } from "../../../apis/news_service";
import { Modal } from "@mui/material";
import { Divider } from "antd";
import CloseIcon from "@mui/icons-material/Close";

export default function NineMemosReports({ stockcode }) {
  const [stockfactorReport, setStockfactorReport] = useState([]);
  const [page, setPage] = useState(1);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);

  useEffect(() => {
    if (stockcode === undefined) {
    } else {
      getStockfactorReportData(stockcode, page);
    }
  }, [stockcode, page]);

  const RenderStockfactorReport = () => {
    if (!stockfactorReport || stockfactorReport.length === 0) {
      return (
        <div className="report_container">
          <div className="report_empty">리포트 뉴스를 준비 중입니다.</div>
        </div>
      );
    }

    return (
      <div className="report_container">
        {stockfactorReport?.map((report, idx) => {
          return (
            <div className="individual_report_container" key={idx}>
              <div
                className="report_card"
                onClick={() => {
                  setModalOpen(true);
                  setModalData({ type: "1", data: report });
                }}
              >
                <p className="report_card_title">Brief Memo</p>
                <div className="report_card_body">
                  {report?.text?.report?.conclusion}
                </div>
                <p className="report_card_footer">
                  {report?.press} ·{" "}
                  {parseLocalDate(report?.registerDateKST).dateText} ·{" "}
                  {parseLocalDate(report?.registerDateKST).timeText} ·{" "}
                  {parseLocalDate(report?.registerDateKST).phase}
                </p>
              </div>
              <div
                className="report_card"
                onClick={() => {
                  setModalOpen(true);
                  setModalData({ type: "2", data: report });
                }}
              >
                <p className="report_card_title">Nine Memo's Outlook</p>
                <div className="report_card_body">
                  {report?.text?.report?.outlook}
                </div>
                <p className="report_card_footer">
                  {report?.press} ·{" "}
                  {parseLocalDate(report?.registerDateKST).dateText} ·{" "}
                  {parseLocalDate(report?.registerDateKST).timeText} ·{" "}
                  {parseLocalDate(report?.registerDateKST).phase}
                </p>
              </div>
              <div
                className="report_card"
                onClick={() => {
                  setModalOpen(true);
                  setModalData({ type: "3", data: report });
                }}
              >
                <p className="report_card_title">Today's Issue</p>
                <div className="report_card_body">
                  {report?.text?.todays_issues?.[0]?.title}
                </div>
                <p className="report_card_footer">
                  {report?.press} ·{" "}
                  {parseLocalDate(report?.registerDateKST).dateText} ·{" "}
                  {parseLocalDate(report?.registerDateKST).timeText} ·{" "}
                  {parseLocalDate(report?.registerDateKST).phase}
                </p>
              </div>
            </div>
          );
        })}
        {page && (
          <button
            type="button"
            className="report_more_btn"
            onClick={() => setPage(page + 1)}
          >
            더보기
          </button>
        )}
      </div>
    );
  };

  const getStockfactorReportData = async (code, page) => {
    const res = await getNewsStockfactorReport({ stockcode: code, page: page });
    if (res.length === 0) {
      setPage(null);
    } else {
      setStockfactorReport((prev) => [...prev, ...res]);
    }
  };

  function parseLocalDate(input) {
    const d = new Date(input); // 그대로 파싱 (이미 해당 국가 시간대라고 가정)

    // 날짜 라벨
    const dateParts = new Intl.DateTimeFormat("ko-KR", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    }).formatToParts(d);

    const year = dateParts.find((p) => p.type === "year")?.value;
    const month = dateParts.find((p) => p.type === "month")?.value;
    const day = dateParts.find((p) => p.type === "day")?.value;

    const dateText = `${year}년 ${month}월 ${day}일`;

    // 시간 라벨: "오전 09:30" / "오후 11:20" 형식
    const timeParts = new Intl.DateTimeFormat("ko-KR", {
      hour12: true,
      hour: "2-digit",
      minute: "2-digit",
    }).formatToParts(d);
    const dayPeriod =
      timeParts.find((p) => p.type === "dayPeriod")?.value || "";
    const hourStr = timeParts.find((p) => p.type === "hour")?.value || "";
    const minuteStr = timeParts.find((p) => p.type === "minute")?.value || "";
    const timeText = `${dayPeriod} ${hourStr}:${minuteStr}`;

    // 정오 기준
    const hour = Number(
      new Intl.DateTimeFormat("en-GB", {
        hour12: false,
        hour: "2-digit",
      }).format(d)
    );

    const phase = hour < 12 ? "장시작" : "장마감";

    return { dateText, timeText, phase };
  }

  const closeModal = () => {
    setModalOpen(false);
    setModalData(null);
  };

  const RenderModal = () => {
    const content = (() => {
      switch (modalData?.type) {
        case "1":
          return (
            <div className="modal_container">
              <div className="modal_title_container">
                <p className="modal_title">{modalData?.data?.stockname}</p>
                <CloseIcon
                  onClick={closeModal}
                  sx={{ width: "24px", height: "24px", cursor: "pointer" }}
                />
              </div>
              <p className="report_card_title" style={{ marginBottom: "5px" }}>
                Brief Memo
              </p>
              <p className="report_card_footer">
                {modalData?.data?.press} ·{" "}
                {parseLocalDate(modalData?.data?.registerDateKST).dateText} ·{" "}
                {parseLocalDate(modalData?.data?.registerDateKST).timeText} ·{" "}
                {parseLocalDate(modalData?.data?.registerDateKST).phase}
              </p>
              <Divider />
              <p className="modal_content">
                {modalData?.data?.text?.report?.conclusion}
              </p>
            </div>
          );
        case "2":
          return (
            <div className="modal_container">
              <div className="modal_title_container">
                <p className="modal_title">{modalData?.data?.stockname}</p>
                <CloseIcon
                  onClick={closeModal}
                  sx={{ width: "24px", height: "24px", cursor: "pointer" }}
                />
              </div>
              <p className="report_card_title" style={{ marginBottom: "5px" }}>
                Nine Memo's Outlook
              </p>
              <p className="report_card_footer">
                {modalData?.data?.press} ·{" "}
                {parseLocalDate(modalData?.data?.registerDateKST).dateText} ·{" "}
                {parseLocalDate(modalData?.data?.registerDateKST).timeText} ·{" "}
                {parseLocalDate(modalData?.data?.registerDateKST).phase}
              </p>
              <Divider />
              <p className="modal_content">
                {modalData?.data?.text?.report?.outlook}
              </p>
            </div>
          );
        case "3":
          return (
            <div className="modal_container">
              <div className="modal_title_container">
                <p className="modal_title">{modalData?.data?.stockname}</p>
                <CloseIcon
                  onClick={closeModal}
                  sx={{ width: "24px", height: "24px", cursor: "pointer" }}
                />
              </div>
              <p className="report_card_title" style={{ marginBottom: "5px" }}>
                Today's Issue
              </p>
              <p className="report_card_footer">
                {modalData?.data?.press} ·{" "}
                {parseLocalDate(modalData?.data?.registerDateKST).dateText} ·{" "}
                {parseLocalDate(modalData?.data?.registerDateKST).timeText} ·{" "}
                {parseLocalDate(modalData?.data?.registerDateKST).phase}
              </p>
              <Divider />
              {modalData?.data?.text?.todays_issues?.map((issue) => {
                return (
                  <div className="modal_content">
                    <p className="modal_content_title">{issue?.title}</p>
                    <p className="modal_content_content">{issue?.content}</p>
                  </div>
                );
              })}
            </div>
          );
        default:
          return <p>No content</p>;
      }
    })();
    return (
      <Modal open={modalOpen} onClose={closeModal} sx={{ outline: "none" }}>
        {content}
      </Modal>
    );
  };

  return (
    <div style={{ padding: "40px 0" }}>
      <RenderModal />
      <p className="title_sm">리포트</p>
      <RenderStockfactorReport />
    </div>
  );
}
